import * as React from 'react'

import {
  GetTaskDetailDocument,
  GetTaskDetailsDocument,
  TasksValueObjectsTaskIdentifierEnum,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import Header from 'modules/tasks/components/TaskDetails/Header'

const RootPage = React.lazy(() => import('../pages/RootPage'))
const NewPage = React.lazy(() => import('../pages/NewPage'))
const ShowPage = React.lazy(() => import('../pages/ShowPage'))
const TasksPage = React.lazy(() => import('../pages/TasksPage/index'))

export const tasksRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.tasks.path,
      element: <RootPage />,
      handle: {
        module: 'tasks',
        meta: () => {
          return {
            title: i18n.t('tasks.header'),
            description: i18n.t('tasks.meta_data.tasks_page.description'),
            illustration: 'check',
          }
        },
      },
      children: [
        {
          index: true,
          element: <TasksPage />,
        },
        {
          path: navigation.tasks.taskId.path, // FIXME: Replace all reference of this with taskIdAndIdentifier instead
          handle: {
            resource: true,
            meta: ({ params, watchQuery }) => {
              const id = params['taskId']
              if (!id) return { title: '' }
              return watchQuery({
                query: GetTaskDetailDocument,
                fetchPolicy: 'cache-first',
                variables: {
                  id: Number(id),
                },
              }).map((result) => {
                const task = result?.data?.tasks?.task
                if (!task) return { title: '' }
                return {
                  title: i18n.t('tasks.meta_data.task_detail_page.title', {
                    task_name: task.name || '',
                  }),
                  description: i18n.t('tasks.meta_data.task_detail_page.description', {
                    task_name: task.name || '',
                  }),
                  headerComponent: <Header task={task} />,
                }
              })
            },
          },
          children: [
            {
              index: true,
              element: <ShowPage />,
            },
          ],
        },
        {
          path: navigation.tasks.taskIdAndIdentifier.path,
          handle: {
            resource: true,
            meta: ({ params, watchQuery, session }) => {
              const id = params['taskId']
              if (!id) return { title: '' }
              const identifier = String(params['identifier'])
              return watchQuery({
                query: GetTaskDetailsDocument,
                fetchPolicy: 'cache-first',
                variables: {
                  ids: [Number(id)],
                  companyId: session.company.id,
                  identifier: identifier as TasksValueObjectsTaskIdentifierEnum, // eslint-disable-line no-type-assertion/no-type-assertion
                },
              }).map((result) => {
                const task = result?.data?.tasks?.tasks[0]
                if (!task) return { title: '' }
                return {
                  title: i18n.t('tasks.meta_data.task_detail_page.title', {
                    task_name: task.name || '',
                  }),
                  description: i18n.t('tasks.meta_data.task_detail_page.description', {
                    task_name: task.name || '',
                  }),
                  headerComponent: <Header task={task} />,
                }
              })
            },
          },
          children: [
            {
              index: true,
              element: <ShowPage />,
            },
          ],
        },
        {
          path: navigation.tasks.new.path,

          handle: {
            meta: () => ({
              title: 'New task',
              description: '',
            }),
          },
          element: <NewPage />,
        },
      ],
    },
  ]
}
